import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const layoutsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "layouts",
}).lazy(() => import("./index.lazy").then((d) => d.Route));
